import type { ProjectSchema } from '~/@pages_investing/projects/_project_types/project.types'

export function getPayoutDate(project: ProjectSchema) {
  return project.paymentDates.sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  )[0]?.date
}
